import React from "react";
import { Card } from "antd";
import { openNewReportPortal } from "../../../../utils/reportUrl";

const ModernViewCard = ({ newReportUrl }) => {
  return (
    <div className="redirect-card-container">
      <Card
        className="redirect-card"
        onClick={() => openNewReportPortal(newReportUrl)}
      >
        <div className="redirect-content">
          <div className="sparkle-icon">{"\u2728"}</div>
          <h2>New Version Available</h2>
          <p>
            Experience the future of reporting with our modern, high-performance interface.
            All your data, now with better visibility and faster insights.
          </p>
          <div className="redirect-btn">Explore Modern View {"\u2728"}</div>
        </div>
      </Card>
    </div>
  );
};

export default ModernViewCard;
